import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const JobListings = () => {
  const jobs = [
    {
      id: 1,
      title: 'Graphic Designer Internship',
      location: 'Ahmedabad, Gujarat (On-Site)',
      type: 'Internship',
      experience: '0-1 years',
      description: 'We are seeking a creative and enthusiastic Graphic Designer Intern to join our team. This role offers an excellent opportunity to gain hands-on experience in Amazon product listing design, A+ content creation, and brand store development.',
      responsibilities: [
        'Create visually appealing product images and infographics for Amazon listings',
        'Assist in designing A+ content that effectively communicates product features and benefits',
        'Help develop brand store layouts that enhance the shopping experience',
        'Collaborate with the content team to ensure design elements align with brand guidelines',
        'Learn and apply Amazon\'s image requirements and best practices',
        'Participate in brainstorming sessions for creative solutions'
      ],
      requirements: [
        'Currently pursuing or recently completed a degree in Graphic Design or related field',
        'Proficiency in Adobe Creative Suite (Photoshop, Illustrator, InDesign)',
        'Basic understanding of UI/UX design principles',
        'Strong attention to detail and ability to meet deadlines',
        'Good communication and teamwork skills',
        'Portfolio demonstrating creative abilities',
        'Knowledge of e-commerce design is a plus'
      ],
      benefits: [
        'Hands-on experience in e-commerce design',
        'Mentorship from experienced designers',
        'Exposure to Amazon\'s ecosystem',
        'Certificate upon completion',
        'Performance-based stipend',
        'Flexible work hours'
      ]
    }
  ];

  return (
    <section className="py-16 bg-gray-50 dark:bg-black">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid gap-8">
          {jobs.map((job) => (
            <motion.div
              key={job.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="bg-white dark:bg-gray-900 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-6">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">{job.title}</h3>
                  <div className="flex flex-wrap gap-3">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                      {job.location}
                    </span>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                      {job.type}
                    </span>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200">
                      {job.experience}
                    </span>
                  </div>
                </div>
                <Link
                  to="https://www.linkedin.com/company/trioperspective/"
                  className="inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-lg text-base font-medium text-white bg-primary hover:bg-primary/90 transition-colors duration-300"
                >
                  Apply Now
                </Link>
              </div>

              <div className="space-y-6">
                <div>
                  <p className="text-gray-600 dark:text-gray-300 mb-4">{job.description}</p>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">Key Responsibilities:</h4>
                  <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-300">
                    {job.responsibilities.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">Requirements:</h4>
                  <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-300">
                    {job.requirements.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">Benefits:</h4>
                  <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-300">
                    {job.benefits.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JobListings;
